<div class="page">
    <div class="page-content content" *ngFor="let part of parts;">
        <h1>Privacy policy</h1>
        <div class="section-webpage-part" *ngFor="let question of part;index as i;" >
            <h2 *ngIf="(environment.domain == 'aesthetics' && i !== 0 ) || environment.domain != 'aesthetics'" [innerHTML]="translationService.getTranslatedAttribute('title', question.translations, locale)"></h2>
            <p [innerHTML]="translationService.getTranslatedAttribute('text', question.translations, locale)"></p>
        </div>
    </div>
</div>